/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ action: NonNullable<unknown> }} Common_Auth_Gate_DescriptionInputs */

const en_common_auth_gate_description = /** @type {(inputs: Common_Auth_Gate_DescriptionInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Sign in or create a free account to ${i?.action}.`)
};

const zh_common_auth_gate_description = /** @type {(inputs: Common_Auth_Gate_DescriptionInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`登录或注册一个免费账号,即可${i?.action}。`)
};

/**
* | output |
* | --- |
* | "Sign in or create a free account to {action}." |
*
* @param {Common_Auth_Gate_DescriptionInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const common_auth_gate_description = /** @type {((inputs: Common_Auth_Gate_DescriptionInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Common_Auth_Gate_DescriptionInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_common_auth_gate_description(inputs)
	return zh_common_auth_gate_description(inputs)
});
export { common_auth_gate_description as "common.auth.gate.description" }